import { render, staticRenderFns } from "./GetSupportMessages.vue?vue&type=template&id=59b75273&"
import script from "./GetSupportMessages.vue?vue&type=script&lang=js&"
export * from "./GetSupportMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports